/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect, useRef } from 'react';

import VideoPlayerOverlay from '../../../../VideoPlayerOverlay';
import DeleteSectionIcon from '../../../../CreateMeetingFooter/DeleteSectionIcon';
import WaveForm from '../../../../MediaContainer/WaveForm';

import classes from './styles.module.scss';

let waveFormTimer;

export default function MiniPlayer({
  meeting,
  signedS3Url,
  title,
  videoDuration,
  isPlaying,
  setIsPlaying,
  setIsMiniPlayerVisible,
  audioSectionsWithoutBackground,
  videoRef,
  miniVideoRef,
}) {
  const [
    currentAudioSectionWithoutBackground,
    setCurrentAudioSectionWithoutBackground,
  ] = useState(null);
  const [currentAudioSectionProgress, setCurrentAudioSectionProgress] =
    useState(0);

  const progressBarRef = useRef();
  const containerRef = useRef();
  const waveFormContainerRef = useRef();

  const playButtonHandler = () => {
    if (!videoRef.current || !miniVideoRef.current) return;
    videoRef.current.currentTime = miniVideoRef.current.currentTime;
    miniVideoRef.current.play();
    videoRef.current.play();
    setIsPlaying?.(true);
    //  animateProgressBar();
  };

  const pauseButtonHandler = () => {
    if (!videoRef.current || !miniVideoRef.current) return;
    miniVideoRef.current.pause();
    videoRef.current.pause();
    videoRef.current.currentTime = miniVideoRef.current.currentTime;
    setIsPlaying?.(false);
    // stopAnimation();
  };

  useEffect(() => {
    const calculateCurrentAudioSectionProgress = (
      currentTime,
      currentAudioSection
    ) => {
      const sectionCurrentTime = currentTime - currentAudioSection.startTime;
      const sectionProgress =
        (1 / currentAudioSection.section.duration) * sectionCurrentTime;

      return Math.min(Math.abs(sectionProgress), 1);
    };

    const showWaveForm = () => {
      if (!audioSectionsWithoutBackground.length) {
        return;
      }

      const currentTime = miniVideoRef.current?.currentTime;

      const currentAudioSection = audioSectionsWithoutBackground.find(
        (sect) => {
          return (
            sect.startTime - 0.3 <= currentTime && sect.endTime >= currentTime
          );
        }
      );

      if (currentAudioSection) {
        setCurrentAudioSectionWithoutBackground(currentAudioSection);
        const sectionProgress = calculateCurrentAudioSectionProgress(
          currentTime,
          currentAudioSection
        );
        setCurrentAudioSectionProgress(sectionProgress);
      } else {
        setCurrentAudioSectionWithoutBackground(null);
      }
    };

    waveFormTimer = setInterval(() => {
      showWaveForm();
    }, 50);

    return () => {
      clearInterval(waveFormTimer);
    };
  }, [audioSectionsWithoutBackground, miniVideoRef, videoDuration]);

  return (
    <div className={classes.MiniPlayer} ref={containerRef}>
      <div className={classes.videoOverlay}>
        <VideoPlayerOverlay
          videoRef={miniVideoRef}
          viewOnly
          noHeader
          meetingTitle={meeting ? meeting.title : title}
          videoDuration={videoDuration}
          isPlaying={isPlaying}
          videoSectionPlayerRef={miniVideoRef}
          progressBarRef={progressBarRef}
          stopVideoPlayer={pauseButtonHandler}
          pauseVideoPlayer={pauseButtonHandler}
          startVideoPlayer={playButtonHandler}
          isVideoReady={!!videoDuration}
          arePlayerButtonsVisible={!!videoDuration}
          noFullscreen
          noSubtitles
          isEditPage
          secondaryVideoRef={videoRef}
          miniPlayer
        />
      </div>
      {currentAudioSectionWithoutBackground && (
        <div className={classes.waveFormContainer} ref={waveFormContainerRef}>
          <WaveForm
            source={currentAudioSectionWithoutBackground.section.signedS3Url}
            containerRef={containerRef}
            fullHeight
            seek={currentAudioSectionProgress}
          />
        </div>
      )}
      <video
        playsInline
        src={`${meeting ? meeting.signedS3Url : signedS3Url}#t=0.001`}
        ref={miniVideoRef}
        muted
      />
      <DeleteSectionIcon onClick={() => setIsMiniPlayerVisible(false)} />
    </div>
  );
}
